import './index.less';

//checkApp 为全局的 app 对象，checkApp.core 包括了核心 api 
const { Feature, meta, hook } = checkApp.core;//eslint-disable-line
const { Tooltip } = checkApp.components;//eslint-disable-line

//通过继承 Featrue 实现一个扩展
//meta 用于描述插件的名称、依赖及权重
@meta('cnPrice', [], 99999)
export default class CNPriceFeature extends Feature {

  /**
   * 渲染售价
   * @param {obejct} item 域名项
   * @returns {object} dom
   */
  @hook('checkItemInfo.renderPrice')
  renderPrice(item) {
    return <span className="price">
      ￥{item.price || item.prices.activate.tradePrice || 0} /首年
    </span>;
  }

  @hook('checkItemInfo.renderRenewalPrice')
  renderRenewalPrice(item) {
    return <a className="renewal-price hidden-xs more-price">
      <Tooltip
        trigger={<span>更多价格<i className="icon icon-down"></i></span>}>
        {this.renderPriceList(item.priceList)}
      </Tooltip>
    </a>;
  }

  renderPriceList(priceList) {
    const activateList = priceList.filter(item => item.action != 'renew');
    const renewList = priceList.filter(item => item.action == 'renew');
    return <table className="price-table">
      <tbody>
        <tr>
          <td colSpan="4">新注价格</td>
          <td colSpan="4">续费价格</td>
        </tr>
        <tr>
          <td>1年</td><td>3年</td><td>5年</td><td>10年</td>
          <td>1年</td><td>3年</td><td>5年</td><td>10年</td>
        </tr>
        <tr>
          {activateList
            .map((item, index) => (<td key={index}>{item.money}</td>))}
          {renewList
            .map((item, index) => (<td key={index}>{item.money}</td>))}
        </tr>
      </tbody>
    </table>;
  }

}


// WEBPACK FOOTER //
// ./src/price/index.js